import { render, staticRenderFns } from "./MvStyle.vue?vue&type=template&id=475e829a&"
import script from "./MvStyle.vue?vue&type=script&lang=ts&"
export * from "./MvStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports